import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FloatingParticles from "../components/FloatingParticles";
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";


/* ─── STYLES ─────────────────────────────────────────────────────────────── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

  .dp-root {
    min-height: 100vh;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    font-family: 'Outfit', sans-serif;
    color: #1e293b;
    position: relative;
    padding: 40px 24px 80px;
  }

  .dp-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  .dp-back-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 14px;
    background: white;
    border: 1px solid #e0f2fe;
    color: #0369a1;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 32px;
    box-shadow: 0 4px 12px rgba(186, 230, 253, 0.15);
  }
  .dp-back-btn:hover {
    transform: translateX(-5px);
    box-shadow: 0 8px 20px rgba(186, 230, 253, 0.3);
    background: #f0f9ff;
  }

  .dp-card {
    background: #ffffff;
    border-radius: 30px;
    border: 1px solid #e0f2fe;
    box-shadow: 0 20px 50px rgba(186, 230, 253, 0.4);
    overflow: hidden;
  }

  .dp-hero-section {
    padding: 40px;
    display: flex;
    gap: 32px;
    border-bottom: 1px solid #f1f5f9;
    background: linear-gradient(to right, #ffffff, #f0f9ff);
  }

  .dp-profile-img {
    width: 160px;
    height: 160px;
    border-radius: 24px;
    object-fit: cover;
    border: 4px solid #fff;
    box-shadow: 0 10px 25px rgba(2, 132, 199, 0.15);
  }

  .dp-profile-placeholder {
    width: 160px;
    height: 160px;
    border-radius: 24px;
    background: #f0f9ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    color: #0284c7;
    font-weight: 800;
    border: 4px solid #fff;
    box-shadow: 0 10px 25px rgba(2, 132, 199, 0.15);
  }

  .dp-hero-content { flex: 1; }
  .dp-name { font-size: 32px; font-weight: 800; color: #0c4a6e; margin-bottom: 4px; }
  .dp-spec { font-size: 16px; font-weight: 700; color: #0284c7; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 16px; }

  .dp-badge-group { display: flex; flex-wrap: wrap; gap: 12px; }
  .dp-badge {
    padding: 8px 18px;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 700;
  }
  .dp-badge-active { background: #dcfce7; color: #16a34a; border: 1px solid #bbf7d0; }
  .dp-badge-exp { background: #f0f9ff; color: #0369a1; border: 1px solid #bae6fd; }
  .dp-badge-fee { background: #fffbeb; color: #d97706; border: 1px solid #fef3c7; }

  .dp-details-grid { padding: 40px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
  .dp-detail-item { background: #f8fafc; border-radius: 20px; padding: 20px; border: 1px solid #f1f5f9; }
  .dp-detail-label { font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; }
  .dp-detail-value { font-size: 16px; font-weight: 700; color: #1e293b; }

  .dp-booking-card {
    background: #ffffff;
    border-radius: 30px;
    border: 2px solid #0284c7;
    box-shadow: 0 25px 60px rgba(2, 132, 199, 0.2);
    padding: 32px;
  }
  .dp-booking-title { font-size: 22px; font-weight: 800; color: #0c4a6e; margin-bottom: 4px; }
  .dp-booking-sub { font-size: 14px; color: #64748b; margin-bottom: 32px; }

  .dp-form-group { margin-bottom: 20px; }
  .dp-label { display: block; font-size: 13px; font-weight: 700; color: #475569; margin-bottom: 8px; }
  .dp-input {
    width: 100%;
    padding: 14px 18px;
    border-radius: 14px;
    border: 2px solid #f1f5f9;
    background: #f8fafc;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    outline: none;
    transition: all 0.3s ease;
  }
  .dp-input:focus { border-color: #0284c7; background: #fff; box-shadow: 0 0 0 4px rgba(2, 132, 199, 0.1); }

  .dp-fee-box {
    background: #f0f9ff;
    padding: 18px;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1.5px solid #bae6fd;
    margin: 24px 0;
  }
  .dp-fee-label { font-size: 13px; font-weight: 700; color: #475569; }
  .dp-fee-value { font-size: 20px; font-weight: 800; color: #0369a1; }

  .dp-submit-btn {
    width: 100%;
    padding: 16px;
    border-radius: 16px;
    border: none;
    background: linear-gradient(135deg, #0284c7, #0ea5e9);
    color: #fff;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 10px 25px rgba(2, 132, 199, 0.3);
  }
  .dp-submit-btn:hover { transform: translateY(-3px); box-shadow: 0 15px 35px rgba(2, 132, 199, 0.5); }
  .dp-submit-btn:active { transform: translateY(-1px); }

  .dp-additional-group {
    background: #f8fafc;
    border-radius: 16px;
    padding: 20px;
    border: 1px solid #e2e8f0;
    margin-bottom: 24px;
  }
  .dp-additional-title {
    font-size: 14px;
    font-weight: 700;
    color: #475569;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .dp-email-chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
  .dp-email-chip {
    background: #e0f2fe;
    color: #0369a1;
    padding: 6px 12px;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #bae6fd;
  }
  .dp-remove-email {
    cursor: pointer;
    color: #ef4444;
    font-size: 14px;
    transition: color 0.2s;
  }
  .dp-remove-email:hover {
    color: #b91c1c;
  }
  .dp-add-participant-box {
    display: flex;
    gap: 8px;
  }
  .dp-add-btn {
    padding: 10px 16px;
    border-radius: 12px;
    background: #0284c7;
    color: white;
    border: none;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
  }
  .dp-add-btn:hover {
    background: #0369a1;
  }

  @media (max-width: 900px) {
    .dp-hero-section { flex-direction: column; text-align: center; items: center; }
    .dp-details-grid { grid-template-columns: 1fr; }
  }
`;

const DoctorProfile = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [doctor, setDoctor] = useState(null);
    const [userEmail, setUserEmail] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [duration, setDuration] = useState("");
    const [user, setUser] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [emailVerified, setEmailVerified] = useState(false);
    const [appointmentType, setAppointmentType] = useState("online");
    const [location, setLocation] = useState("");
    const [additionalParticipants, setAdditionalParticipants] = useState([]);
    const [newParticipantEmail, setNewParticipantEmail] = useState("");
    const [reason, setReason] = useState("");
    const styleInjected = useRef(false);
    const [timer, setTimer] = useState(0);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [locationSchedules, setLocationSchedules] = useState([]);

    useEffect(() => {
        if (!styleInjected.current) {
            const tag = document.createElement("style");
            tag.textContent = STYLES;
            document.head.appendChild(tag);
            styleInjected.current = true;
        }
    }, []);
    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        const fetchDoctor = async () => {
            try {
                const res = await axios.get(`${API}/api/doctors/${id}`);
                setDoctor(res.data);
                
                // Fetch location schedules
                const schedulesRes = await axios.get(`${API}/api/doctors/${res.data.id}/location-schedules`);
                setLocationSchedules(schedulesRes.data || []);
            } catch (err) {
                console.error(err);
                toast.error("Doctor not found or failed to load schedules");
            }
        };
        fetchDoctor();
    }, [id]);

    useEffect(() => {
        const u = JSON.parse(localStorage.getItem("user"));
        if (u) {
            setUser(u);
            setUserEmail(u.email);
        }
    }, []);

    useEffect(() => {
        const fetchAvailableSlots = async () => {
            if (!date || !duration || !doctor) return;
            try {
                const res = await axios.get(`${API}/api/appointments/doctor/${doctor.id}?date=${date}`);
                const booked = Array.isArray(res.data) ? res.data.filter(a => a.status === "confirmed").map(a => {
                    const [h, m] = a.time.split(":").map(Number);
                    const start = h * 60 + m;
                    return { start, end: start + (Number(a.duration) || 30) };
                }) : [];

                const [startH, startM] = doctor.availability_start.split(":").map(Number);
                const [endH, endM] = doctor.availability_end.split(":").map(Number);
                let startMinutes = startH * 60 + startM;
                const endMinutes = endH * 60 + endM;
                const slotMinutes = parseInt(duration, 10);
                const slots = [];
                const now = new Date();

                while (startMinutes + slotMinutes <= endMinutes) {
                    const h = Math.floor(startMinutes / 60);
                    const m = startMinutes % 60;
                    const slotStart = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

                    // ✅ FIXED DATE CREATION
                    const [year, month, day] = date.split("-").map(Number);
                    const slotDateTime = new Date(year, month - 1, day, h, m);

                    const isBlocked = booked.some(
                        (b) => startMinutes < b.end && startMinutes + slotMinutes > b.start
                    );

                    // ✅ THIS IS WHERE YOUR CODE GOES
                    const isToday =
                        now.getFullYear() === year &&
                        now.getMonth() === month - 1 &&
                        now.getDate() === day;

                    const isFutureTime = !isToday || slotDateTime > now;

                    // ✅ FINAL CONDITION
                    if (isFutureTime && !isBlocked) {
                        const eh = Math.floor((startMinutes + slotMinutes) / 60);
                        const em = (startMinutes + slotMinutes) % 60;

                        slots.push({
                            value: slotStart,
                            label: `${slotStart} → ${String(eh).padStart(2, "0")}:${String(em).padStart(2, "0")}`
                        });
                    }

                    startMinutes += slotMinutes;
                }
                setAvailableSlots(slots);
            } catch (err) {
                console.error(err);
                setAvailableSlots([]);
            }
        };
        fetchAvailableSlots();
    }, [doctor, date, duration]);

    const sendOtp = async () => {
        if (otpLoading) return;

        if (!userEmail) {
            return toast.error("Enter your email first");
        }

        try {
            setOtpLoading(true);

            await axios.post(
                `${API}/api/auth/send-otp-booking`,
                {
                    email: userEmail,
                }
            );

            toast.success("OTP sent to your email");
            setOtpSent(true);
            setTimer(30);

        } catch (err) {
            toast.error(
                err.response?.data?.message || "Failed to send OTP"
            );
        } finally {
            setOtpLoading(false);
        }
    };

    const verifyOtp = async () => {
        if (!otp) return toast.error("Enter the OTP");
        try {
            await axios.post(`${API}/api/auth/verify-otp-booking`, { email: userEmail, otp });
            toast.success("Verified!");
            setEmailVerified(true);
        } catch (err) {
            toast.error("Invalid OTP");
        }
    };

    const handleBooking = async () => {
        if (bookingLoading) return; // 🚫 prevent double click

        if (!user || !doctor || !date || !time || !duration) {
            return toast.error("Please complete all sections");
        }

        if (appointmentType === "offline" && !location) {
            return toast.error("Please select a location");
        }

        try {
            setBookingLoading(true);

            const res = await axios.post(`${API}/api/appointments`, {
                doctor_id: doctor.id,
                user_id: user.id,
                date,
                time,
                duration: parseInt(duration),
                appointment_type: appointmentType,
                location: appointmentType === 'offline' ? location : null,
                additional_participants: additionalParticipants,
                reason: reason
            });

            toast.success("Appointment booked! 💊");
            navigate("/appointments");

        } catch (err) {
            // ✅ This will show the EXACT backend message in the toast
            const message = err.response?.data?.message || "Failed to book appointment";
            console.error("Booking error:", err.response?.data); // ✅ full details in console
            toast.error(message);
        } finally {
            setBookingLoading(false);
        }
    };

    if (!doctor) return null;

    const initials = doctor.name?.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) || "DR";

    return (
        <div className="dp-root">
            <FloatingParticles />
            <div className="dp-container">
                <button className="dp-back-btn" onClick={() => navigate("/doctors")}>
                    <span>⬅</span> Back to Dashboard
                </button>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Left & Center: Info Card */}
                    <div className="lg:col-span-2">
                        <div className="dp-card">
                            <div className="dp-hero-section">
                                {doctor.profile_image ? (
                                    <img src={`${API}/uploads/doctors/${doctor.profile_image}`} alt={doctor.name} className="dp-profile-img" />
                                ) : (
                                    <div className="dp-profile-placeholder">{initials}</div>
                                )}
                                <div className="dp-hero-content">
                                    <h1 className="dp-name">{doctor.name}</h1>
                                    <p className="dp-spec">{doctor.specialization}</p>
                                    <div className="dp-badge-group">
                                        <span className={`dp-badge ${doctor.is_active ? "dp-badge-active" : "bg-red-100 text-red-700"}`}>
                                            {doctor.is_active ? "🟢 Available" : "🔴 Offline"}
                                        </span>
                                        <span className="dp-badge dp-badge-exp">🎓 {doctor.experience} yrs experience</span>
                                        <span className="dp-badge dp-badge-fee">💰 ₹{doctor.consultation_fee} / visit</span>
                                    </div>
                                </div>
                            </div>

                            <div className="dp-details-grid">
                                <div className="dp-detail-item">
                                    <p className="dp-detail-label">Hospital / Clinic</p>
                                    <p className="dp-detail-value">{doctor.clinic_name || "Private Clinic"}</p>
                                </div>
                                <div className="dp-detail-item">
                                    <p className="dp-detail-label">City Location</p>
                                    <p className="dp-detail-value">📍 {doctor.city || "Not Specified"}</p>
                                </div>
                                <div className="dp-detail-item col-span-2">
                                    <p className="dp-detail-label">Full Address</p>
                                    <p className="dp-detail-value">{doctor.address || "Please contact clinic for exact address."}</p>
                                </div>
                                <div className="dp-detail-item">
                                    <p className="dp-detail-label">Working Hours</p>
                                    <p className="dp-detail-value">⏰ {doctor.availability_start} – {doctor.availability_end}</p>
                                </div>
                                <div className="dp-detail-item">
                                    <p className="dp-detail-label">Consultation Fee</p>
                                    <p className="dp-detail-value">₹{doctor.consultation_fee}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right: Booking Card */}
                    <div>
                        {!user ? (
                            <div className="dp-card" style={{ padding: "40px 20px", textAlign: "center" }}>
                                <h3 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1rem" }}>Login Required</h3>
                                <p style={{ color: "#64748b", marginBottom: "1.5rem" }}>
                                    You need to be logged in to book an appointment with this doctor.
                                </p>
                                <button
                                    onClick={() => navigate("/login")}
                                    className="dp-submit-btn"
                                >
                                    Go to Login
                                </button>
                            </div>
                        ) : (
                            <div className="dp-card">
                                {/* Email */}
                                <div className="dp-form-group">
                                    <label className="dp-label">Email Address</label>
                                    <input
                                        type="email"
                                        value={userEmail}
                                        readOnly
                                        className="dp-input"
                                        style={{ background: "#e2e8f0", cursor: "not-allowed" }}
                                    />
                                </div>

                                {/* OTP SECTION */}
                                {!emailVerified && (
                                    <>
                                        {!otpSent && (
                                            <button
                                                onClick={sendOtp}
                                                className="dp-submit-btn"
                                                disabled={otpLoading}
                                                style={{
                                                    opacity: otpLoading ? 0.6 : 1,
                                                    cursor: otpLoading ? "not-allowed" : "pointer"
                                                }}
                                            >
                                                {otpLoading ? "Sending OTP..." : "Send Security OTP"}
                                            </button>
                                        )}

                                        {otpSent && (
                                            <>
                                                <div className="dp-form-group">
                                                    <label className="dp-label">Enter OTP</label>
                                                    <input
                                                        type="text"
                                                        value={otp}
                                                        onChange={(e) => setOtp(e.target.value)}
                                                        className="dp-input"
                                                        placeholder="6-digit code"
                                                    />
                                                </div>

                                                <button onClick={verifyOtp} className="dp-submit-btn">
                                                    Verify OTP
                                                </button>

                                                {/* 🔁 RESEND SECTION */}
                                                <div style={{ marginTop: "12px", textAlign: "center" }}>
                                                    {timer > 0 ? (
                                                        <p style={{ fontSize: "13px", color: "#64748b" }}>
                                                            Resend OTP in {timer}s
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={sendOtp}
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                color: "#0284c7",
                                                                fontWeight: "700",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}

                                {/* ✅ SHOW ONLY AFTER VERIFICATION */}
                                {emailVerified && (
                                    <>
                                        {/* Appointment Type */}
                                        <div className="dp-form-group">
                                            <label className="dp-label">Appointment Type</label>
                                            <div style={{ display: "flex", gap: "24px" }}>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        value="online"
                                                        checked={appointmentType === "online"}
                                                        onChange={(e) => setAppointmentType(e.target.value)}
                                                    />
                                                    🌐 Online
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        value="offline"
                                                        checked={appointmentType === "offline"}
                                                onChange={(e) => {
                                                    setAppointmentType(e.target.value);
                                                    setLocation(`${doctor.clinic_name}, ${doctor.city}`);
                                                }}
                                            />
                                            🏥 Offline
                                        </label>
                                    </div>
                                </div>

                                {/* Location */}
                                {appointmentType === "offline" && (
                                    <div className="dp-form-group">
                                        <label className="dp-label">Location</label>
                                        <select
                                            value={location}
                                            onChange={(e) => {
                                                setLocation(e.target.value);
                                                setDate(""); // reset date when location changes
                                            }}
                                            className="dp-input"
                                        >
                                            <option value="">Choose Location</option>
                                            {(() => {
                                                let docClinics = [];
                                                if (doctor.clinics) {
                                                    try { docClinics = JSON.parse(doctor.clinics); }
                                                    catch { docClinics = typeof doctor.clinics === 'string' ? doctor.clinics.split(',').map(c => c.trim()) : []; }
                                                    docClinics = docClinics.map(c => typeof c === 'object' ? c.name : c).filter(Boolean);
                                                }
                                                if (docClinics.length === 0 && doctor.clinic_name) docClinics = [doctor.clinic_name];
                                                
                                                // Combine with schedule clinics if not in profile (edge case)
                                                const scheduleClinics = [...new Set(locationSchedules.map(s => s.clinic_name))];
                                                const allClinics = [...new Set([...docClinics, ...scheduleClinics])];

                                                return allClinics.map((c, i) => (
                                                    <option key={i} value={c}>{c}</option>
                                                ));
                                            })()}
                                        </select>
                                    </div>
                                )}

                                {/* Date */}
                                <div className="dp-form-group">
                                    <label className="dp-label">Select Date</label>
                                    <DatePicker
                                        selected={date ? new Date(date + "T00:00:00") : null}
                                        onChange={(d) => {
                                            const year = d.getFullYear();
                                            const month = String(d.getMonth() + 1).padStart(2, "0");
                                            const day = String(d.getDate()).padStart(2, "0");

                                            const formatted = `${year}-${month}-${day}`;
                                            setDate(formatted);
                                            setTime("");
                                        }}
                                        minDate={new Date()}
                                        filterDate={(d) => {
                                            if (appointmentType === 'offline' && location) {
                                                const year = d.getFullYear();
                                                const month = String(d.getMonth() + 1).padStart(2, "0");
                                                const day = String(d.getDate()).padStart(2, "0");
                                                const dateStr = `${year}-${month}-${day}`;
                                                
                                                const schedulesForLoc = locationSchedules.filter(s => s.clinic_name === location);
                                                return schedulesForLoc.some(s => s.date === dateStr);
                                            }
                                            return true;
                                        }}
                                        dateFormat="yyyy-MM-dd"
                                        className="dp-input"
                                    />
                                </div>

                                {/* Duration */}
                                <div className="dp-form-group">
                                    <label className="dp-label">Duration</label>
                                    <select
                                        value={duration}
                                        onChange={(e) => {
                                            setDuration(e.target.value);
                                            setTime("");
                                        }}
                                        className="dp-input"
                                    >
                                        <option value="">Select</option>
                                        {[15, 30, 45, 60].map((v) => (
                                            <option key={v} value={v}>
                                                {v} min
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Reason */}
                                <div className="dp-form-group">
                                    <label className="dp-label">Reason for Appointment</label>
                                    <textarea
                                        className="dp-input"
                                        placeholder="Briefly describe your symptoms or reason for visit"
                                        rows="2"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        style={{ resize: "vertical", fontFamily: "inherit" }}
                                    ></textarea>
                                </div>

                                {/* Additional Participants */}
                                <div className="dp-additional-group">
                                    <div className="dp-additional-title">
                                        <span>Invite Others (Optional)</span>
                                        <span style={{ fontSize: '11px', color: '#64748b' }}>{additionalParticipants.length}/5 participants</span>
                                    </div>

                                    <div className="dp-add-participant-box">
                                        <input
                                            type="email"
                                            placeholder="Friend or family email"
                                            className="dp-input"
                                            value={newParticipantEmail}
                                            onChange={(e) => setNewParticipantEmail(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    const email = newParticipantEmail.trim();
                                                    if (email && !additionalParticipants.includes(email)) {
                                                        if (additionalParticipants.length >= 5) {
                                                            toast.warning("Max 5 participants allowed");
                                                            return;
                                                        }
                                                        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                                            toast.error("Invalid email address");
                                                            return;
                                                        }
                                                        setAdditionalParticipants([...additionalParticipants, email]);
                                                        setNewParticipantEmail("");
                                                    }
                                                }
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="dp-add-btn"
                                            onClick={() => {
                                                const email = newParticipantEmail.trim();
                                                if (email && !additionalParticipants.includes(email)) {
                                                    if (additionalParticipants.length >= 5) {
                                                        toast.warning("Max 5 participants allowed");
                                                        return;
                                                    }
                                                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                                        toast.error("Invalid email address");
                                                        return;
                                                    }
                                                    setAdditionalParticipants([...additionalParticipants, email]);
                                                    setNewParticipantEmail("");
                                                }
                                            }}
                                        >
                                            Add
                                        </button>
                                    </div>

                                    {additionalParticipants.length > 0 && (
                                        <div className="dp-email-chip-list">
                                            {additionalParticipants.map((email, idx) => (
                                                <div key={idx} className="dp-email-chip">
                                                    {email}
                                                    <span
                                                        className="dp-remove-email"
                                                        onClick={() => setAdditionalParticipants(additionalParticipants.filter(e => e !== email))}
                                                    >
                                                        ✕
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Slots */}
                                <div className="dp-form-group">
                                    <label className="dp-label">Time Slots</label>
                                    <select
                                        value={time}
                                        onChange={(e) => setTime(e.target.value)}
                                        className="dp-input"
                                    >
                                        <option value="">Select Slot</option>
                                        {availableSlots.map((s, i) => (
                                            <option key={i} value={s.value}>
                                                {s.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Fee */}
                                <div className="dp-fee-box">
                                    <span>Total</span>
                                    <span>₹{doctor.consultation_fee}</span>
                                </div>

                                {/* Final Button */}
                                <button
                                    onClick={handleBooking}
                                    className="dp-submit-btn"
                                    disabled={bookingLoading}
                                    style={{
                                        opacity: bookingLoading ? 0.6 : 1,
                                        cursor: bookingLoading ? "not-allowed" : "pointer"
                                    }}
                                >
                                    {bookingLoading ? "Booking..." : "Confirm Appointment"}
                                </button>
                            </>
                        )}
                            </div>
                        )}
                    </div>
                </div>

                {appointmentType === "offline" && (
                    <div className="dp-form-group">
                        <label className="dp-label">Select Location (Available on Date)</label>
                        <select value={location} onChange={(e) => setLocation(e.target.value)} className="dp-input">
                            <option value="">Choose a Location</option>
                            <option value={`${doctor.clinic_name || "Clinic"}, ${doctor.city || "City"}`}>
                                {doctor.clinic_name || "Private Clinic"} - {doctor.city || "City"}
                            </option>
                            {doctor.address && (
                                <option value={doctor.address}>
                                    Full Address: {doctor.address}
                                </option>
                            )}
                        </select>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DoctorProfile;